<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="日期">
              <a-range-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
        <a-row :gutter="48" style="height:50px">
          <a-col>
            <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      :isInquire="false"
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, download } from '@/api/statement/hireWorkCost'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { attendGroupList } from '@/api/common/AttendGroup'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
export default {
  name: 'WorkerCost',
  mixins: [TableMixin],
  data () {
    return {
      projectList: [], // 项目
      groupList: [], // 考勤组
      workerTypeList: [], // 工人类别
      showable: false,
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        groupId: undefined,
        startTime: undefined,
        endTime: undefined,
        typeId: undefined
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '队伍名称',
          dataIndex: 'teamName'
        },
        {
          title: '工作内容',
          dataIndex: 'content'
        },
        {
          title: '费用金额',
          dataIndex: 'totalPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
      attendGroupList().then(res => {
        this.groupList = res.data
      })
      dropSxWorkerTypeList().then(res => {
        this.workerTypeList = res.data
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '外雇工人成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
